import React from 'react'
import { Icon, Popup } from 'semantic-ui-react'

const RawMessageCell: React.FC<{ content: object }> = props => (
  <Popup
    content={
      <pre className='cbgms-grid__raw-json-cell'>
        <code className='cbgms-grid__raw-json-cell-code'>{JSON.stringify(props.content, null, 2)}</code>
      </pre>
    }
    on='click'
    trigger={<Icon fitted link name='code' />}
  />
)

RawMessageCell.displayName = 'RawMessageCell'

export default RawMessageCell
